module.exports = __webpack_public_path__ + "img/hykd.672b684b.png";